import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PpcEyebrow } from '@design-system/eyebrow/eyebrow';
import { PpcHeading } from '@design-system/heading/heading';

@Component({
  selector: 'app-footer',
  imports: [TranslatePipe, PpcEyebrow, PpcHeading],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class FooterComponent {
  protected readonly year = new Date().getFullYear();
}
